import { Pause, Play, SkipBack } from 'lucide-react';
import { Button } from '../ui';
import { fmtDuration } from '../../lib/format';

const RATES = [1, 5, 20];
export default function ReplayControls({ t, span, playing, rate, onToggle, onSeek, onRate }: { t: number; span: number; playing: boolean; rate: number; onToggle: () => void; onSeek: (v: number) => void; onRate: (r: number) => void }) {
  return (
    <div className="flex items-center gap-3 px-3 py-2 hud text-sm">
      <Button size="sm" variant="ghost" onClick={() => onSeek(0)} title="Restart"><SkipBack className="h-4 w-4" /></Button>
      <Button size="sm" variant="primary" onClick={onToggle} title={playing ? 'Pause' : 'Play'}>{playing ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4" />}</Button>
      <span className="w-14 text-right">{fmtDuration(t)}</span>
      <input type="range" min={0} max={span} step={0.5} value={t} onChange={e => onSeek(Number(e.target.value))} className="flex-1" aria-label="scrub" />
      <span className="w-14 text-dim">{fmtDuration(span)}</span>
      <div className="flex gap-1">{RATES.map(r => <Button key={r} size="sm" variant={rate === r ? 'primary' : 'default'} onClick={() => onRate(r)}>{r}×</Button>)}</div>
    </div>
  );
}
